/* eslint-disable no-unused-vars */
import React from 'react';
import { Hidden } from "@material-ui/core";
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie';
import { setAuthen, setRoles } from '../libs/todoSlice';
import Cookie from '../lib/Cookie';
import fontColor from '../lib/fontColor';
import { logoutSession } from '../lib/logoutRedirect';

function Error404() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [ cookie, setCookie, removeCookie ] = useCookies(['access_token', 'account', 'new_user'])
  const logout = async () => {
    await logoutSession({
      removeCookie,
      dispatch,
      oauth: cookie.oauth,
      prefix: '',
    })
  };
  return (
    <div
      style={{
        background: 'linear-gradient(90deg, #053075 -2.5%, #063889 22.06%, #063E98 48.22%, #0848B0 76.51%, #0850C4 100%)', 
        height: '100vh',
      }}
    >
      <div style={{ padding: '30px 80px 0 80px' }}>
      <img
          // src="/logo.png"
          src="/one-platform.png"
          alt=""
          style={{ 
            maxHeight: '70px',
            maxWidth: '70px',
          }}
        />
        <span
          style={{
            fontWeight: '600',
            color: '#FFFFFF',
            padding: '10px',
          }}
        >One Platform</span>

        {localStorage.getItem('account') && 
        <span
        style={{ 
          float: 'right',
        }}
        >
          <Button
          onClick={() => {
            logout()
          }}
          sx={{
            color: fontColor('#053075'),
            justifyContent: 'center',
            alignItems: 'center',
            padding: '9px 15px',
            gap: '10px',
            width: '120px',
            height: '36px',
            background: '#053075',
            borderRadius: '6px',
            float: 'right',
          }}
          >
            ออกจากระบบ
          </Button>
        </span>
        }
      </div>
      <Hidden mdDown>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <img
            src="/img_login_RA.png"
            style={{
              position: 'fixed',
              width: '670.75px',
              height: '650.54px',
              top: '110px',
            }}
            alt=''
          />
        </div>
      </Hidden>
      <div style={{ color: 'white', letterSpacing: '0.02em', padding: '100px 80px' }}>
        <div>
          <div style={{ fontSize: '40px', fontWeight: '300' }}><span>404 ERROR</span></div>
          <div style={{ fontSize: '30px', paddingTop: '10px', fontWeight: '300' }}><span>Page Not Found!</span></div>
          <div style={{ fontSize: '20px', paddingTop: '15px', fontWeight: '300' }}><span>We're sorry, the page you requested could not be found. <br /> Please go back to the homepage!</span></div>
        </div>
        <div style={{ marginTop: '20px' }}>
          <Button
            style={{
              width: '184px',
              background: '#F6911F',
              borderRadius: '6px',
              color: 'white'
            }}
            onClick={() => {
              navigate('/')
            }}
          >
            <span>GO HOME</span>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Error404
